export const AUTH0_TOKEN_EXPIRATION_PERIOD_MS: number = 30 * 60 * 1000;
export const AUTH0_SESSION_REQUIRE_LOGOUT_SEC: number = 8 * 60 * 60;
export const REFRESH_TOKEN_DURATION_MS: number = 5 * 1000;
